import type { RHFGroupFieldValue } from '@/components/dynamic-filter/FilterFormGroup';
import type { TicketTypeResponse } from '@/types/apps/ticket-type.type';
import type { GqlListResponse } from '@/types/common/api.type';
import { BaseService } from '@/types/service/graphql-service.type';

export interface TicketTypeGraphQLServiceInterface {}

type TicketTypeGraphQLListResponse = GqlListResponse<TicketTypeResponse>;

export class TicketTypeGraphQLService
    extends BaseService
    implements TicketTypeGraphQLServiceInterface
{
    public getEntityName(): string {
        return 'ticketType';
    }

    public getFields(): Record<string, any> {
        return {
            createdBy: true,
            createdDate: true,
            deletedAt: true,
            deletedBy: true,
            description: true,
            id: true,
            isDeleted: true,
            modifiedBy: true,
            modifiedDate: true,
            name: true,
            type: true,
            taskCheckTypeId: true,
            taskCheckType: {
                createdDate: true,
                description: true,
                id: true,
                name: true,
            },
        };
    }

    public async index(query: string): Promise<TicketTypeGraphQLListResponse> {
        return this.fetchGqlList<TicketTypeGraphQLListResponse>(
            query,
            this.getEntityName()
        );
    }

    public getFilterByRole(): Record<string, RHFGroupFieldValue> {
        if (!this.getQueryById() || !this.getRoleTypeManager().getQuery) {
            return {};
        }

        return this.getRoleTypeManager().getQuery('ticketType', {
            userId: this.getQueryById(),
        });
    }
}
